import { useState } from 'react';
import loginBackgroundImage from '../../assets/login-background.png';

export const Login = ({ onLoginSuccess }) => {
  const [error, setError] = useState();
  const checkPassword = (e) => {
    const password = e.target.password.value;
    // console.log('Password: %o', password);
    if (password !== 'Salt2025') {
      setError('The passcode you have entered is incorrect. Please try again.');
    } else {
      onLoginSuccess?.();
    }
    e.preventDefault();
  };

  const handleInputChange = () => {
    setError(null);
  };

  return (
    <div className="loginOverlay">
      <div className="background">
        <img src={loginBackgroundImage} alt="Login" />
      </div>
      <div className="formContainer">
        <div className="formDescription">
          The pilot version of our ecosystem and network mapping tools are only available to SaltExchange members. If you're interested in joining the
          community, please <a href="mailto:tabi@saltexchange.com">contact us</a>.
        </div>
        <form onSubmit={(e) => checkPassword(e)}>
          <input type="password" name="password" placeholder="Enter the passcode to continue" onChange={() => handleInputChange()} />
          <div>
            <button type="submit">Submit</button>
          </div>
          <div className="formError">{error}&nbsp;</div>
        </form>
      </div>
    </div>
  );
};
